require('./documentsTable.scss');

// @ vendor
const React = require('react');
const { FormattedText, getLanguage } = require('core/i18n').i18n;
const classNames = require('classnames');
const Immutable = require('immutable');
const PropTypes = require('prop-types');

// @ commons
const { OKTableGroupHeader } = require('commonsComponents/OKTableGroupHeader');
const { OKTable } = require('commonsComponents/OKTable');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');

// @ components
const { DocumentRow } = require('components/myProfile/documentsTable/documentRow');
const WebappRender = require('components/conditionalRender/webappRender');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender');

// @ helpers
const { classifyItemsByDate } = require('commonsUtilities/tableMovementsHelper');

// @ constants
const RECENT_DOCUMENTS = 'recents';
const { LAST_MOVEMENTS_TABLE_CURRENT_MONTH_KEY } = require('constants/commonsComponents');
const { STATEMENTS_TYPES_TO_SEND } = require('constants/contactCenter/sendExtractsViaMail');

class DocumentsTable extends React.Component {
    getDocumentAlias(immDocument) {
        return immDocument.get('numContrato');
    }

    buildAliasCol() {
        const { showAlias } = this.props;

        if (showAlias) {
            return (
                <OKTableCell className="document-table__alias" asHeader={true}>
                    <FormattedText value="profileDocumentation-documentationAlias" />
                </OKTableCell>
            );
        }

        return null;
    }

    buildColumnTitles() {
        const { showCurrentDocument, showDocumentationType, groupSelected } = this.props;
        const currentCol = showCurrentDocument ? this.buildCurrentCol() : null;
        const aliasCol = this.buildAliasCol();
        const documentationTypeCol = showDocumentationType ? this.buildDocumentationTypeCol() : null;
        const mifid2SendEmailButtonCol = (__CONTACT_CENTER__ && groupSelected === 'MIFID2') ? <OKTableCell className="document-table__right-action" asHeader={true} /> : null;

        return (
            <thead>
                <OKTableRow asHeader={true}>
                    <OKTableCell className="document-table__date" asHeader={true}>
                        <FormattedText value="profileDocumentation-documentationDate" />
                    </OKTableCell>
                    {documentationTypeCol}
                    {currentCol}
                    {aliasCol}
                    {mifid2SendEmailButtonCol}
                    <OKTableCell className="document-table__right-action" asHeader={true} />
                </OKTableRow>
            </thead>
        );
    }

    buildCurrentCol() {
        const content = (
            <OKTableCell className="document-table__current" asHeader={true}>
                <FormattedText value="documents-documentationActive" />
            </OKTableCell>
        );

        return content;
    }

    buildDocumentationTypeCol() {
        const { showAlias } = this.props;
        const docTypeClassName = classNames({
            'document-table__document-type': showAlias
        });
        return (
            <OKTableCell className={docTypeClassName} asHeader={true}>
                <FormattedText value="profileDocumentation-documentationType" />
            </OKTableCell>
        );
    }

    isStatementMail(immDocument){
        return STATEMENTS_TYPES_TO_SEND.includes(immDocument.get('codGrupoComunicacion', ''));
    }

    buildTableContent(data) {
        let response;
        const {
            callbackDownloadFile,
            callbackDownloadFiscalFile,
            callbackDownloadMifid2File,
            callbackSendMifid2DocumentByEmail,
            linkSquare,
            maxDocumentsToSee,
            setSelectedDocument,
            showAlias,
            showAutoDates,
            showCurrentDocument,
            showDocumentationType,
            hideDateCell,
            isContractsInForce,
            downloadById 
          } = this.props;

        const createItems = (immDocument, index) => {
            if (immDocument.get('hidden')) return null;

            const documentAlias = this.getDocumentAlias(immDocument);

            
            const date =immDocument.get('registrationDate')|| immDocument.get('fechaEnvio') || immDocument.get('fechaAlta');
            const isStatementMail = this.isStatementMail(immDocument);
            const isFiscalFileType = immDocument.get('isFiscalFileType');

            const cbDownloadFile = isFiscalFileType ? callbackDownloadFiscalFile : callbackDownloadFile;

            const row = (
                <DocumentRow
                    callbackDownloadFile={cbDownloadFile}
                    callbackDownloadMifid2File={callbackDownloadMifid2File}
                    callbackSendMifid2DocumentByEmail={callbackSendMifid2DocumentByEmail}
                    currentDocument={immDocument.get('currentDocument')}
                    date={date}
                    documentAlias={documentAlias}
                    documentType={immDocument.get('nombreTipoComunicacion')}
                    documentTypeId={immDocument.get('documentType')}
                    file={immDocument.get('file')}
                    immDocument={immDocument}
                    isFetching={immDocument.get('isFetching')}
                    isError={immDocument.get('isError')}
                    key={index}
                    linkSquare={linkSquare}
                    showAlias={showAlias}
                    showCurrentDocument={showCurrentDocument}
                    showDocumentationType={showDocumentationType}
                    url={immDocument.get('url')}
                    isMifid2Document={immDocument.get('isMifid2Document')}
                    hideDateCell={hideDateCell}
                    downloadById={downloadById}
                    documentId={immDocument.get('documentId')}
                    mifid2SendEmailButton={immDocument.get('mifid2SendEmailButton')}
                    documentWithNoDates={immDocument.get('documentWithNoDates')}
                    isContractsInForce={isContractsInForce}
                    isStatementMail={isStatementMail}
                    setSelectedDocument={setSelectedDocument}
                />
            );

            return (maxDocumentsToSee < 0 || index + 1 <= maxDocumentsToSee) ? row : null;

        };

        const createItemsWithDates = entry => {
            const key = entry[0];
            const items = entry[1];

            if (items && items.size) {
                let tableHeader;
                const tableRows = items.map(createItems);
                const groupHeaderClassName =
                    'account-last-movements-table__group-header last-movements-table__group-header';

                // If the group is tagged as "recents", the header of the group
                // in the table will not be displayed.

                if (key !== RECENT_DOCUMENTS) {
                    tableHeader = (
                        <tr>
                            <OKTableGroupHeader colSpan={6} className={groupHeaderClassName}>
                                {key}
                            </OKTableGroupHeader>
                        </tr>
                    );
                }
                if (tableRows.filter(x => x).size) {
                    return (
                        <tbody key={key} className="last-movements-table__body">
                            {tableHeader}
                            {tableRows}
                        </tbody>
                    );
                }
            }
        };

        if (data && data.size) {
            let wrappedData = data;
            // Here we check if the data is a List or a Map. Recent data is
            // returned as a List instead as a Map. In this case, we wrap the
            // List inside a Map with a property "recents".

            if (showAutoDates && Immutable.List.isList(data)) {
                wrappedData = Immutable.fromJS({
                    [RECENT_DOCUMENTS]: data
                });
            }

            if (showAutoDates) {
                response = wrappedData.entrySeq().map(createItemsWithDates);
            } else {
                response = (
                    <tbody>
                        {wrappedData.map(createItems)}
                    </tbody>
                );
            }

            return response;
        }
    }

    render() {
        const { data, showAutoDates, hideTableHeader } = this.props;
        let columnTitles = !hideTableHeader && this.buildColumnTitles();
        const {
            immFutureItems,
            immRecentItems,
            immCurrentMonthItems,
            immCurrentYearItems,
            immItemsWithoutDate,
            immOldYearItems
        } = classifyItemsByDate(data, LAST_MOVEMENTS_TABLE_CURRENT_MONTH_KEY, getLanguage(), 'fechaAlta');

        return (showAutoDates) ?  (
            <OKTable>
                {columnTitles}

                <WebappRender>
                    {this.buildTableContent(immFutureItems)}
                </WebappRender>

                {this.buildTableContent(immRecentItems)}
                {this.buildTableContent(immCurrentMonthItems)}
                {this.buildTableContent(immCurrentYearItems)}
                {this.buildTableContent(immOldYearItems)}

                <ContactCenterRender>
                    {this.buildTableContent(immItemsWithoutDate)}
                </ContactCenterRender>

            </OKTable>
        ) : (
            <OKTable>
                {columnTitles}
                {this.buildTableContent(data)}
            </OKTable>
        );
    }
}

DocumentsTable.propTypes = {
    callbackDownloadFile: PropTypes.func,
    downloadById: PropTypes.func,
    callbackDownloadFiscalFile: PropTypes.func,
    callbackDownloadMifid2File: PropTypes.func,
    callbackSendMifid2DocumentByEmail: PropTypes.func,
    currentDocument: PropTypes.bool,
    data: PropTypes.object,
    immAccounts: PropTypes.object,
    linkSquare: PropTypes.bool,
    maxDocumentsToSee: PropTypes.number,
    showAlias: PropTypes.bool,
    showAutoDates: PropTypes.bool,
    showCurrentDocument: PropTypes.bool,
    showDocumentationType: PropTypes.bool,
    isContractsInForce: PropTypes.bool,
    groupSelected: PropTypes.string,

    hideDateCell: PropTypes.bool,
    hideTableHeader: PropTypes.bool,
    setSelectedDocument: PropTypes.func
};

DocumentsTable.defaultProps = {
    maxDocumentsToSee: -1,
    showAutoDates: true,
    hideDateCell: false,
    hideTableHeader: false,
    isContractsInForce: false
};

module.exports = DocumentsTable;
